import logo from './logo.svg'

export const theme = {
  color: {
    primary: "#87c2e4",
    primaryHover: "#69b2dd",
  },
  logoImage: logo,
  backend: "https://epaper.kulturzeitschrift.at/",
  directory: "/kiosk",
  header: {
    lineHeader: true,
    title: "Zeitschrift für Kultur und Gesellschaft",
    link: 'https://www.kulturzeitschrift.at/'
  },
  tracking: {
    type: 'Matomo',
    urlBase: 'https://matomo.kombinat.at/',
    siteId: 34,
    cookieConsent: {
      type: 'Free'
    }
  },
  info: [
    {
      text: 'Impressum',
      link: 'https://www.kulturzeitschrift.at/impressum'
    },
    {
      text: 'Datenschutz',
      link: 'https://www.kulturzeitschrift.at/impressum'
    },],
  login: {
    type: "internal",
    resetEmail: "sekretariat@kulturzeitschrift.at",
    subscriptionTitle: "Noch kein Abo?",
    subscriptionText: "Schließen Sie jetzt ein Abonnement der Zeitschrift für Kultur und Gesellschaft ab und genießen Sie den vollen Zugriff auf die aktuelle Ausgabe und das Archiv.",
    links: [{
      id: 1,
      text: 'Jetzt abonnieren',
      url: "https://www.kulturzeitschrift.at/bestellen"
    }
    ]
  }
};